export default __webpack_public_path__ + "static/media/mesure.e497ee43.svg";